import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";

export const CustomTooltip = ({
  position = "left",
  content = "",
  children,
}) => (
  <OverlayTrigger
    placement={position}
    delay={{ show: 200, hide: 300 }}
    overlay={(props) => (
      <Tooltip id="button-tooltip" {...props}>
        {content}
      </Tooltip>
    )}
  >
    {children}
  </OverlayTrigger>
);
